// This file is generated.
export const version = "2.1.0";
